<template>
    <div class="dataStatistics">
        <div class="title-box">
            <img class="cion" src="@/assets/home/dateLeft-icon.png"></img>
            <span>性别分布</span>
        </div>
        <div class="cont-box2">
            <div class="pieBox">
                <PieChart :chartDate="chartDate" height="220px"></PieChart>
            </div>
            <div class="right-tuli">
                <div class="right-item" v-for="(item,index) in chartDate" :key="index">
                    <div class="sex">
                        <span :style="{background: item.itemStyle.color}" class="yuan"></span>
                        <span>{{item.name}}</span>
                    </div>
                    <div class="sex-num">{{item.value}}人</div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import drawMixin from "@/utils/drawMixin";
    import PieChart from '@/components/home/PieChart.vue';

    import {
        formatTime
    } from "@/utils/index.js";
    import { genderStatistics } from '@/api/common.js'
    export default {
        // mixins: [drawMixin],
        data() {
            return {
                num: '232',
                chartDate: [],
            };
        },
        components: {
            PieChart
        },
        mounted() {


        },
        beforeDestroy() {

        },
        created() {
            this.init()
        },
        methods: {
            init() {
                let arr = [
                    { value: 0, name: '男', itemStyle: { color: '#57FFE2' } },
                    { value: 0, name: '女', itemStyle: { color: '#FFA5C4' } }
                ]
                genderStatistics().then(res => {
                    if (res.code == 200) {
                        arr[0].value = res.data.maleCount
                        arr[1].value = res.data.femaleCount
                        this.chartDate = arr
                        // console.log('性别分布',this.chartDate)
                    }
                })
            }
        },
    };
</script>

<style lang="scss" scoped>
    /* @import "../../../assets/scss/index.scss"; */

    .dataStatistics {
        /* background-image: url(../../../assets/home/bg-1.png); */
        background: linear-gradient( 180deg, rgba(32,65,116,.3) 0%, rgba(113,161,246,.3) 100%);
        background-size: 100% 100%;
        margin-bottom: 10px;
        box-sizing: border-box;

        .title-box {
            width: 100%;
            height: 42px;
            background-image: url(../../../assets/home/title-box-bg.png);
            background-size: 100% 100%;
            font-family: Alimama ShuHeiTi, Alimama ShuHeiTi;
            font-weight: bold;
            font-size: 16px;
            color: #FFFFFF;
            display: flex;
            align-items: center;

            .cion {
                width: 34px;
                height: 35px;
                margin-right: 10px;
            }
        }

        .cont-box2 {
            width: 100%;
            height: 220px;
            display: flex;

            .pieBox {
                flex: 1;
            }

            .right-tuli {
                flex: 1;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;

                .right-item {
                    width: 100%;
                    display: flex;
                    margin-bottom: 35px;

                    >div {
                        font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
                        font-weight: normal;
                        font-size: 18px;
                        color: #FFFFFF;
                        display: flex;
                        flex: 1;

                    }

                    .sex {



                        .yuan {
                            width: 20px;
                            height: 20px;
                            border-radius: 50%;
                            background-color: #fff;
                            margin-right: 10px;
                        }
                    }

                    .sex-num {}
                }

                .right-item:last-child {
                    margin-bottom: 0;
                }
            }
        }





    }
</style>